/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const currencyTokens = {
  FontColorGainDefault: '#237c70',
  FontColorLossDefault: '#c41936',
  FontWeightBaseDefault: '400',
  FontSizeBaseDefault: '14px',
  FontLeadingBaseDefault: '24px',
} as const;
